import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  flex: 1 1 auto;
  position: relative;
  width: 100%;
  padding: 0 0.75rem;
  margin-bottom: 0.75rem;

  ${Styles.desktop`
    margin-bottom: 1rem;
    padding: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: ${Styles.layout.sectionMaxWidth};
    width: calc(100% - 6rem);
  `}
`;

export const LeftContainer = styled.div`
  ${Styles.desktop`
    display: flex;
    flex: 1;
    padding-right: .5rem;
  `}
`;

export const RightContainer = styled.div`
  ${Styles.desktop`
    display: flex;
    flex: 1;
    padding-left: .5rem;
  `}
`;

export const QuadTileContainer = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  ${Styles.desktop`
    max-width: 50rem;
    grid-gap: 1rem;
  `}
`;
